import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import TaiSanApi from "service/taiSanApi";
import Pagination from "react-js-pagination";
import configs from "constants/configs";

export const ChiTietTaiSan1 = (props) => {
  const taiSanId = props.taiSanId;
  // const [stores] = useState(initStore);
  const chiTietTaiSan = {
    TenTaiSan: "",
    Code: "",
    StoreName: "",
    Note: "",
  };

  const AnhTaiSan = [];
  const searchLichSuTaiSan = {
    taiSanId: taiSanId,
    pageSize: 5,
    pageIndex: 1,
    totalRow: 0,
  };

  const [contentChiTietTaiSan, setContentChiTietTaiSan] =
    useState(chiTietTaiSan);

  const [setSearchLichSuTaiSan, setSearchLichSuTaiSan1] =
    useState(searchLichSuTaiSan);
  const [listAnhTaiSan, setAnhTaiSan] = useState(AnhTaiSan);
  const [listLichSuTaiSan, setListLichSuTaiSan] = useState();

  let currentSlider = null;
  const runSlider = () => {
    setTimeout(() => {
      // Init fancyBox
      window.$().fancybox({
        selector: ".slick-slide:not(.slick-cloned)",
        hash: false,
      });
      if (currentSlider) currentSlider.slick("unslick");
      currentSlider = window.$("#main-slider1").slick({
        slidesToShow: 7,
        slidesToScroll: 7,
        infinite: true,
        dots: false,
        arrows: true,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
            },
          },
        ],
      });
      window.$("#main-slider1").resize();
    }, 100);
  };

  useEffect(() => {
    TaiSanApi.getDetail({ taiSanId }).then((response) => {
      setContentChiTietTaiSan(response.data.ThongTinTaiSan);
      setAnhTaiSan(response.data.AnhTaiSan);
    });
    DanhSachLichSu();
    runSlider();
  }, []);
  const DanhSachLichSu = () => {
    TaiSanApi.getLichSuTaiSan1(
      setSearchLichSuTaiSan.taiSanId,
      setSearchLichSuTaiSan.pageSize,
      setSearchLichSuTaiSan.pageIndex
    ).then((response) => {
      setListLichSuTaiSan(response.data.List);
    });
  };

  const handlePageChange = (pageNumber) => {
    setSearchLichSuTaiSan.pageIndex = pageNumber;
    setSearchLichSuTaiSan.pageSize = 1;
    DanhSachLichSu();
  };

  //   const returnImageLink = (strImage) => {
  //     var imageTS = strImage;
  //     strImage && strImage.indexOf("http") > -1
  //       ? strImage
  //       : configs.imageServer + imageTS;
  //     //     var imageTS = strImage
  //     //       ? configs.imageServer + imageTS
  //     //       : "/app-assets/images/no_image.png";
  //     // if (imageTS && imageTS.indexOf("http") > -1) imageTS = strImage;
  //     return imageTS;
  //   };

  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-clipboard-list-outline"></i>
          </span>{" "}
          Thông tin tài sản
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253"
                className="card-header border-info"
                href="#collapse253"
                aria-expanded="true"
                aria-controls="collapse253"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Chi tiết tài sản</h3>
                </a>
              </div>
              <div
                id="collapse253"
                aria-labelledby="headingCollapse253"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="main-slider slider-ts" id="main-slider1">
                      {listAnhTaiSan &&
                        listAnhTaiSan.map((item) => (
                          <a
                            href={
                              item.Url && item.Url.indexOf("http") > -1
                                ? item.Url
                                : configs.apiViewUpload + item.Url
                            }
                            data-fancybox="images"
                          >
                            <img
                              src={
                                item.Url && item.Url.indexOf("http") > -1
                                  ? item.Url
                                  : configs.apiViewUpload + item.Url
                              }
                              alt=""
                            />
                          </a>
                        ))}
                    </div>
                    <div className="form-body form-bordered-1">
                      <div className="form-group row">
                        <label className="col-md-3 label-control">
                          Tên tài sản
                        </label>
                        <div className="col-md-9">
                          {contentChiTietTaiSan.TenTaiSan}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 label-control">
                          Mã tài sản
                        </label>
                        <div className="col-md-9">
                          {contentChiTietTaiSan.Code}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-3 label-control">Kho</label>
                        <div className="col-md-9">
                          {contentChiTietTaiSan.StoreName}
                        </div>
                      </div>

                      <div className="form-group row last-1">
                        <label className="col-md-3 label-control">
                          Ghi chú
                        </label>
                        <div className="col-md-9">
                          {contentChiTietTaiSan.Note}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                id="headingCollapse25324"
                className="card-header border-info mt-1"
                href="#collapse25324"
                aria-expanded="true"
                aria-controls="collapse25324"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Lịch sử tài sản</h3>
                </a>
              </div>
              <div
                id="collapse25324"
                aria-labelledby="headingCollapse25324"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="table-responsive table-2">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>STT</th>
                            <th>Thời gian</th>
                            <th>Khách hàng</th>
                            <th>Số tiền</th>
                            <th>Lý do</th>
                            <th>Người tạo</th>
                            <th>Ghi chú</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listLichSuTaiSan &&
                            listLichSuTaiSan.map((item, index) => (
                              <tr>
                                <td>{item.IndexId}</td>
                                <td>{item.Time}</td>
                                <td>{item.CustomerName}</td>
                                <td>{item.Sotienvay}</td>
                                <td>{item.LyDo}</td>
                                <td>{item.UserCreate}</td>
                                <td>{item.Note}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div
                      className={
                        "paniation-new paniation-new1 d-flex justify-content-center mt-1" +
                        (setSearchLichSuTaiSan.totalRow <=
                        setSearchLichSuTaiSan.pageSize
                          ? " hidden"
                          : "")
                      }
                    >
                      <nav aria-label="Page navigation">
                        <Pagination
                          activePage={setSearchLichSuTaiSan.pageIndex}
                          itemsCountPerPage={setSearchLichSuTaiSan.pageSize}
                          totalItemsCount={setSearchLichSuTaiSan.totalRow}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                          activeClass="active"
                        />
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
